import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import AuthPage from "./pages/AuthPage";
import HomePage from "./pages/HomePage";
import InterpretPage from "./pages/InterpretPage";
import JournalPage from "./pages/JournalPage";
import DreamDetailPage from "./pages/DreamDetailPage";
import SignsPage from "./pages/SignsPage";
import WellnessPage from "./pages/WellnessPage";
import AnalysisPage from "./pages/AnalysisPage";
import ProfilePage from "./pages/ProfilePage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import LegalPage from "./pages/LegalPage";
import ContactPage from "./pages/ContactPage";
import ArticlePage from "./pages/ArticlePage";
import CookieBanner from "./components/CookieBanner";

function AuthRequired({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0F172A" }}>
        <div className="w-8 h-8 border-2 border-amber-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  return user ? children : <Navigate to="/auth" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public pages - no auth required */}
      <Route path="/" element={<HomePage />} />
      <Route path="/interpret" element={<InterpretPage />} />
      <Route path="/signs" element={<SignsPage />} />
      <Route path="/wellness" element={<WellnessPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/article/:slug" element={<ArticlePage />} />

      {/* Auth required pages */}
      <Route path="/journal" element={<AuthRequired><JournalPage /></AuthRequired>} />
      <Route path="/journal/:dreamId" element={<AuthRequired><DreamDetailPage /></AuthRequired>} />
      <Route path="/analysis" element={<AuthRequired><AnalysisPage /></AuthRequired>} />
      <Route path="/profile" element={<AuthRequired><ProfilePage /></AuthRequired>} />
      <Route path="/subscription/success" element={<AuthRequired><SubscriptionSuccessPage /></AuthRequired>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <CookieBanner />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}
